import { GoogleMapsEnterprise } from 'js/components/Maps/GoogleMapsEnterprise.js';
import { Maps } from 'js/components/Maps/index.js';

export class LocationMap extends GoogleMapsEnterprise {
  static initClass() {
    Maps.FactoryForProvider.Google = (data) => new this(data);
    this.instances = [];
    this.providerLoaded = false;
    this.className = "Yext.Maps.LocationMap";
    this.breakPoint = 992;
  }

  constructor(args) {
    super(args);
    this.pinWidth = 32;
    this.pinHeight = 42;
  }

  iconImage(location, i) {
    return {
        url: `data:image/svg+xml;charset=utf8,${encodeURIComponent(this.svgPin())}`,
        scaledSize: new google.maps.Size(this.pinWidth, this.pinHeight)
    }
  }

  svgPin() {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42">
        <path fill="#1A7F99" fill-rule="evenodd" d="M3.55271368e-15,15.4 C3.55271368e-15,6.82 7.08571429,0 16,0 C24.9142857,0 32,6.82 32,15.4 C32,26.84 16,42 16,42 C16,42 3.55271368e-15,26.84 3.55271368e-15,15.4 Z M16,24 C20.418278,24 24,20.418278 24,16 C24,11.581722 20.418278,8 16,8 C11.581722,8 8,11.581722 8,16 C8,20.418278 11.581722,24 16,24 Z"/>
      </svg>
    `;
  }

  setOffsetCenter(latlng, offset) {
    let newCenterLatLng = this.offsetLatLng(latlng, 0, offset.top/2);
    this.map.panTo(newCenterLatLng);
  }

  preparePin(i, loc, m) {
    let pin = super.preparePin(...arguments);
    pin.isDefault = true;
    return pin;
  }
}

LocationMap.initClass();
